import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

export default function ApexRevenueChart({ data }) {
    const theme = useTheme();

    const chartData = React.useMemo(() => (Array.isArray(data) && data.length > 0
        ? data.map(item => ({
            label: item.category || "Other",
            value: parseFloat(item.total || item.revenue || 0)
        }))
        : [
            { label: "Antibiotics", value: 3500 },
            { label: "Painkillers", value: 2500 },
            { label: "Vitamins", value: 1500 },
            { label: "Chronic Care", value: 1200 },
            { label: "Pediatrics", value: 800 }
        ]), [data]);

    const series = React.useMemo(() => chartData.map(item => item.value), [chartData]);
    const labels = React.useMemo(() => chartData.map(item => item.label), [chartData]);

    const options = React.useMemo(() => ({
        chart: {
            id: "dashboard-revenue-polar",
            type: "polarArea",
            fontFamily: "inherit"
        },
        labels: labels,
        fill: { opacity: 0.85 },
        stroke: { width: 2, colors: ["#fff"] },
        theme: {
            monochrome: {
                enabled: true,
                color: theme.palette.primary.main,
                shadeTo: theme.palette.mode === 'dark' ? 'dark' : 'light',
                shadeIntensity: 0.6
            }
        },
        plotOptions: {
            polarArea: {
                rings: { strokeWidth: 1, strokeColor: theme.palette.divider },
                spokes: { strokeWidth: 1, connectorColor: theme.palette.divider }
            }
        },
        legend: {
            position: "bottom",
            fontSize: "12px",
            fontWeight: 500,
            labels: { colors: theme.palette.text.primary },
            onItemClick: { toggleDataSeries: false }
        },
        tooltip: {
            theme: theme.palette.mode,
            y: {
                formatter: (val) => `$${val.toLocaleString()}`
            }
        }
    }), [theme.palette.primary.main, theme.palette.mode, theme.palette.divider, theme.palette.text.primary, labels]);

    return (
        <div className="apex-chart-wrapper" style={{ width: '100%', height: '100%' }}>
            <Chart options={options} series={series} type="polarArea" height="100%" />
        </div>
    );
}
